import {
  Button,
  createToaster,
  Link,
  Portal,
  Spinner,
  Stack,
  Toast,
  Toaster as ChakraToaster,
} from '@chakra-ui/react';
import {
  getAddEthereumChainParameter,
  useDesiredChain,
} from '@cronos-app/wallet';
import { TOAST_DURATION_MS } from '@ui/config/ui';
import { useGlobalChainLayer } from '@ui/hooks/useGlobalChainLayer';

import { MaskIcon } from './MaskIcon';

export const toaster = createToaster({
  placement: 'top-end',
  pauseOnPageIdle: true,
  duration: TOAST_DURATION_MS,
});

export const Toaster = () => {
  const chainLayer = useGlobalChainLayer();
  const desiredChainId = useDesiredChain(chainLayer);

  return (
    <Portal>
      <ChakraToaster toaster={toaster}>
        {(toast) => {
          const title = (() => {
            if (toast.title) return toast.title;
            if (toast.type === 'success') return '(＾▽＾) Success!';
            if (toast.type === 'error') return '(〒︿〒) Failed!';
          })();
          const description = (() => {
            if (toast.description) return toast.description;
            if (toast.type === 'success')
              return 'Your transaction has been successfully proceeded!';
            if (toast.type === 'error') return 'Failed, please try again!';
          })();

          const txHashLink = toast.meta?.txHash
            ? `${
                getAddEthereumChainParameter(desiredChainId)
                  .blockExplorerUrls?.[0]
              }/tx/${toast.meta?.txHash}`
            : undefined;

          return (
            <Toast.Root>
              {toast.type === 'loading' ? (
                <Spinner size="sm" color="blue.solid" />
              ) : null}
              <Stack gap="0" flex="1" maxWidth="100%">
                {title && <Toast.Title>{title}</Toast.Title>}
                {description && (
                  <Toast.Description>{description}</Toast.Description>
                )}
                {txHashLink && (
                  <Button
                    variant="tertiary"
                    color="primary"
                    textStyle="body2Bold"
                    alignSelf="flex-start"
                    mt="8px"
                    asChild
                  >
                    <Link href={txHashLink} target="_blank">
                      View on Explorer{' '}
                      <MaskIcon
                        icon="url(/masks/arrow-outward.svg)"
                        boxSize="16px"
                      />
                    </Link>
                  </Button>
                )}
              </Stack>
              {toast.action && (
                <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>
              )}
              {toast.meta?.closable === false ? null : (
                <Toast.CloseTrigger>
                  <MaskIcon
                    icon="url(/masks/close.svg)"
                    bgColor="currentcolor"
                    boxSize="24px"
                  />
                </Toast.CloseTrigger>
              )}
            </Toast.Root>
          );
        }}
      </ChakraToaster>
    </Portal>
  );
};
